import Dotdotdot from 'react-dotdotdot';

import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';
import { FakeLink } from '@hivebrite/design-system/Link';
import { scaleWithFont } from '@hivebrite/design-system/Theme';

import onEnterPress from 'hb-react/shared/utils/onEnterPress';

import useTopicDescription from '../hooks/useTopicDescription';

export const TopicDescriptionWithoutContext = ({
  canRemoveDescriptionPlaceholder,
  description,
  descriptionVisibleInFrontOffice,
  isConnectedUser,
  name,
  setDisplayDetailsModal,
}) => {
  const height = `${scaleWithFont(34)}px`;

  if (
    !isConnectedUser ||
    !descriptionVisibleInFrontOffice ||
    // note: canRemoveDescriptionPlaceholder is already behind a LD flag
    canRemoveDescriptionPlaceholder
  ) {
    return null;
  }

  if (description) {
    return (
      <Box mx={4} display="block" data-testid="topic-card-description">
        <Divider borderBottomColor="horizon" mt={4} mb={3} />
        <Box height={height} flexDirection="column">
          <Dotdotdot clamp={2} useNativeClamp>
            {description}
          </Dotdotdot>
        </Box>
        <Box mt="6px">
          <FakeLink
            as="span"
            aria-label={s__('Topics|Check more details about %{group}').i__({
              group: name,
            })}
            display="inline"
            onClick={() => setDisplayDetailsModal(true)}
            onKeyPress={onEnterPress(() => setDisplayDetailsModal(true))}
          >
            {s__('Topics|See more')}
          </FakeLink>
        </Box>
      </Box>
    );
  }

  return <Box height="63px" />;
};

const TopicDescription = ({ setDisplayDetailsModal }) => {
  const {
    name,
    canRemoveDescriptionPlaceholder,
    description,
    descriptionVisibleInFrontOffice,
    isConnectedUser,
  } = useTopicDescription();

  return (
    <TopicDescriptionWithoutContext
      canRemoveDescriptionPlaceholder={canRemoveDescriptionPlaceholder}
      description={description}
      descriptionVisibleInFrontOffice={descriptionVisibleInFrontOffice}
      isConnectedUser={isConnectedUser}
      name={name}
      setDisplayDetailsModal={setDisplayDetailsModal}
    />
  );
};

export default TopicDescription;
